import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { createMeal } from '../thunk';

import type { MealInputType } from '@/domain/meal/component/MealFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import MealFormInput from '@/domain/meal/component/MealFormInput';
import { parseTimeByCurrentDate, toStringTime } from '@/utils/date';

/** プロパティ */
export type AddMealInput = {
  /** 開くか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 日付 */
  date?: Date,
};

const AddMeal: React.FC<AddMealInput> = ({
  isOpen,
  close,
  user,
  child,
  facilityList,
  date,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<MealInputType>({
    defaultValues: {
      isYesterday: false,
      mealContent: '',
      measureDateTime: toStringTime(new Date(), false),
    },
  });
  const onSubmit = (input: MealInputType) => {
    const username = user.name;
    const dt = parseTimeByCurrentDate(input.measureDateTime, date);
    if (input.isYesterday) {
      dt.setDate(dt.getDate() - 1);
    }
    dispatch(createMeal({
      data: {
        data: {
          measureDateTime: dt.toJSON(),
          mealContent: input.mealContent,
          measurerId: username,
          measurerType: 'app',
          parentId: username,
          childId: child.childId,
        },
        pub: {
          sendId: `${child.parentId}_${child.childId}`,
          replyId: username,
          data: {},
        },
      },
      facilityIds: facilityList.map((v) => v.data.facilityId),
    }));
    close();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
      fullWidth
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ minWidth: '300px' }}
      >
        <DialogTitle title="食事の登録" />
        <DialogContent>
          <MealFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            color="primary"
          >
            登録する
          </Button>
          <Button
            variant="contained"
            onClick={() => close()}
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddMeal;
